<template>
  <div>
    <span class="text-weight-medium text-tab">Important information:</span>
    <span class="text-tab">
      This calculator is for illustrative purposes only. The figures provided
      are estimates and do not constitute a quote or offer. The figures provided
      are based on the information you provided and a number of factors and
      assumptions. To view these factors and assumptions
      <SAILink
        class="cursor-pointer"
        :href="calculatorAssumptionsHref"
        target="_blank"
        label="click here"
      />.
    </span>
  </div>
</template>

<script>
import { SAILink } from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetTerms',
  props: {
    calculatorAssumptionsHref: String
  },
  components: {
    SAILink
  }
};
</script>
